<div #ticker  *ngIf="show" class="relative flex flex-row w-full items-center whitespace-nowrap rounded-none justify-center overflow-hidden" [ngClass]="{'pr-12' : canClose}" [ngClass]="[typeClasses]">
  <div class="inline-block h-full hover:animation-pause">
    <span class="flex items-center text-nowrap whitespace-nowrap" [ngClass]="size === BannerSize.SM ? 'h-10' : 'h-12' " [innerHTML]="text"></span>
  </div>
  <div *ngIf="canClose" class="absolute right-0 px-2 h-full flex items-center" [ngClass]="[typeClasses]">
    <flow-button theme="light" (onClick)="closeBanner()">
      <app-icon iconName="x" size="md" stroke="#202020"></app-icon>
    </flow-button>
  </div>
</div>
